import axios from "axios";
import { utilityService } from "@/services/utilityService.js";

const getHeaders = () => ({ headers: utilityService.getHeaders() });

async function __getDataCollectionStats (depth) {
  try {
    const url = utilityService.getApiUrl(`report/stats/office/depth/${depth}`);
    return await axios.get(url, getHeaders());
  } catch (error) {
    console.error("Failed to load data collection stats:", error);
    throw error;
  }
}

async function __getDataCollectionStatsReportForOffice (officeId) {
  try {
    const url = utilityService.getApiUrl(`report/stats/office/${officeId}`);
    return await axios.get(url, getHeaders());
  } catch (error) {
    console.error("Failed to load office stats report:", error);
    throw error;
  }
}

async function __getOfficeListAtDepthForReport (depth, reportType) {
  try {
    const url = utilityService.getApiUrl(
      `report/stats/${reportType}/office/depth/${depth}`
    );
    return await axios.get(url, getHeaders());
  } catch (error) {
    console.error("Failed to load office list at depth:", error);
    throw error;
  }
}

async function __getOfficeListAtIdForReport (id, reportType) {
  try {
    const url = utilityService.getApiUrl(
      `report/stats/${reportType}/office/${id}`
    );
    return await axios.get(url, getHeaders());
  } catch (error) {
    console.error("Failed to load office list by ID:", error);
    throw error;
  }
}

async function __getProgressReport () {
  try {
    const url = utilityService.getApiUrl("report/progressreport");
    return await axios.get(url, getHeaders());
  } catch (error) {
    console.error("Failed to load progress report:", error);
    throw error;
  }
}

async function __getSubOfficeProgressReport (surveyId, searchValue) {
  try {
    const url = utilityService.getApiUrl(
      `report/progresssubreport/${surveyId}/office/${searchValue}`
    );
    return await axios.get(url, getHeaders());
  } catch (error) {
    console.error("Failed to load suboffice progress report:", error);
    throw error;
  }
}

async function __getDataCollectionStatsForReport (reportType) {
  try {
    const url = utilityService.getApiUrl(`report/agencylist/${reportType}`);
    return await axios.get(url, getHeaders());
  } catch (error) {
    console.error("Failed to load data collection stats for report:", error);
    throw error;
  }
}

async function __getDataCollectionStatsReportForSuboffices (officeId, statusId) {
  try {
    const url = utilityService.getApiUrl(
      `report/subofficelist/${officeId}/${statusId}`
    );
    return await axios.get(url, getHeaders());
  } catch (error) {
    console.error("Failed to load suboffice stats:", error);
    throw error;
  }
}

async function __getSurveyRootFromId (surveyId) {
  try {
    const url = utilityService.getApiUrl(`report/surveyroot/${surveyId}`);
    return await axios.get(url, getHeaders());
  } catch (error) {
    console.error("Failed to load survey root:", error);
    throw error;
  }
}

async function __getOfficeFromId (officeId) {
  try {
    const url = utilityService.getApiUrl(`report/office/${officeId}`);
    return await axios.get(url, getHeaders());
  } catch (error) {
    console.error("Failed to load office:", error);
    throw error;
  }
}

export const adminDataCollectionService = {
  getDataCollectionStats: __getDataCollectionStats,
  getDataCollectionStatsForOffice: __getDataCollectionStatsReportForOffice,
  getOfficeListAtDepthForReport: __getOfficeListAtDepthForReport,
  getOfficeListAtIdForReport: __getOfficeListAtIdForReport,
  getDataCollectionStatsForReport: __getDataCollectionStatsForReport,
  getDataCollectionStatsReportForOffice: __getDataCollectionStatsReportForOffice,
  getDataCollectionStatsReportForSuboffices: __getDataCollectionStatsReportForSuboffices,
  getProgressReport: __getProgressReport,
  getSurveyRootFromId: __getSurveyRootFromId,
  getOfficeFromId: __getOfficeFromId,
  getSubOfficeProgressReport: __getSubOfficeProgressReport
};
